import {push} from 'react-router-redux'
import {TRANSACTIONS, USER_PROFILE} from '../../../endpoints'
import {apiPrivate} from '../../../api'
import types from '../types/address'
import orchestratorActions from './orchestrator'
import simpleSnackbarActions from '../../../common/actions/simpleSnackbar'
import {endpoint as endpointText} from '../../../common/text'
import {address as text} from '../text'
import {User} from '../../../state/actions'
import loginActions from '../../login/actions/login'

export default class address {

  static setTab(tab) {
    return {
      type: types.SET_TAB,
      payload: {
        tab,
      },
    }
  }

  static setSelected(selected) {
    return {
      type: types.SET_SELECTED,
      payload: {
        selected,
      },
    }
  }

  static setAddress(address) {
    return {
      type: types.SET_ADDRESS,
      payload: {
        value: address,
      },
    }
  }

  static setFloor(floor) {
    return {
      type: types.SET_FLOOR,
      payload: {
        value: floor,
      },
    }
  }

  static setApartment(apartment) {
    return {
      type: types.SET_APARTMENT,
      payload: {
        value: apartment,
      },
    }
  }

  static setPostalCode(postalCode) {
    return {
      type: types.SET_POSTAL_CODE,
      payload: {
        value: postalCode,
      },
    }
  }

  static setStreetNumber(number) {
    return {
      type: types.SET_STREET_NUMBER,
      payload: {
        value: number,
      },
    }
  }

  static saveAdd() {

    return function (dispatch, getState) {

      const state = getState().ui.remove.address

      const address_ = state.getIn(['add', 'address'])
      const number = state.getIn(['add', 'number'])
      const floor = state.getIn(['add', 'floor'])
      const apartment = state.getIn(['add', 'apartment'])
      let postalCode = state.getIn(['add', 'postalCode'])

      if (address_ === '') {
        dispatch(address.saveAddEmptyFields({address: text.completeAddress}))
        return Promise.resolve(false)
      }
      if (number === '') {
        dispatch(address.saveAddEmptyFields({number: text.noStreetNumber}))
        return Promise.resolve(false)
      }
      if (postalCode === '') {
        dispatch(address.saveAddEmptyFields({postalCode: text.noPostalCode}))
        return Promise.resolve(false)
        // postalCode = 'ANY'
      }

      dispatch({type: types.SAVE})

      const data = new FormData()
      data.append('address', address_)
      data.append('number', number)
      data.append('floor', floor)
      data.append('apartment', apartment)
      data.append('postal_code', postalCode)

      const config = {
        headers: {
          'X-Request-Origin': 'usr-web|deposit-3',
        },
      }

      return apiPrivate.post(USER_PROFILE + '/user/address', data, config)
        .then(response => {
          const newAddress = response.data.description
          dispatch(address.saveAddSuccess(newAddress.ID, newAddress.Address, newAddress.Number, newAddress.Floor, newAddress.Apartment, newAddress.PostalCode))
          dispatch(address.setSelected(newAddress.ID))
          return true
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(address.saveAddFail(message))
              return false
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(address.saveAddFail(message))
          return false
        })
    }
  }

  static saveAddSuccess(id, address, number, floor, apartment, postalCode) {
    return {
      type: types.SAVE_SUCCESS,
      payload: {
        address: {
          ID: id,
          Address: address,
          Number: number,
          Floor: floor,
          Apartment: apartment,
          PostalCode: postalCode,
        },
      },
    }
  }

  static saveAddEmptyFields(emptyFieldErrors) {
    const noErrors = {
      address: '',
      number: '',
      postalCode: '',
    }
    return {
      type: types.SET_EMPTY_FIELD_ERROR,
      payload: {
        emptyFieldErrors: {
          ...noErrors,
          ...emptyFieldErrors,
        },
      },
    }
  }

  static saveAddFail(error) {
    return {
      type: types.SAVE_FAIL,
      payload: {
        error,
      },
    }
  }

  static fetch() {
    return function (dispatch) {

      dispatch({type: types.FETCH})

      apiPrivate.get(USER_PROFILE + '/user/profile')
        .then(response => {
          const data = response.data.description
          dispatch(address.fetchSuccess(data))
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(address.fetchFail(message))
              return
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(address.fetchFail(message))
          dispatch(simpleSnackbarActions.showMessage(message))
        })
    }
  }

  static fetchSuccess(data) {
    return {
      type: types.FETCH_SUCCESS,
      payload: {
        addresses: data.Addresses,
      },
    }
  }

  static fetchFail(error) {
    return {
      type: types.FETCH_FAIL,
      payload: {
        error,
      },
    }
  }

  static modifyTransaction() {
    return function (dispatch, getState) {

      const state = getState().ui.remove.address

      const transaction = getState().ui.remove.start.getIn(['transaction', 'ID'])
      const selected = state.get('selected')
      const selectedAddress = state.get('addresses').find(a => {
        return a.ID === selected
      })

      if (selected === 0)
        return dispatch(address.modifyTransactionFail(''))

      dispatch({type: types.MODIFY_TRANSACTION})

      const data = new FormData()
      data.append('address', selected)

      apiPrivate.put(TRANSACTIONS + '/transactions/' + transaction, data)
        .then(response => {
          dispatch(address.modifyTransactionSuccess(selectedAddress))
          dispatch(orchestratorActions.nextStepFromAddress())
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(address.modifyTransactionFail(message))
              return
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(address.modifyTransactionFail(message))
          dispatch(simpleSnackbarActions.showMessage(message))
        })
    }
  }

  static modifyTransactionSuccess(address) {
    return {
      type: types.MODIFY_TRANSACTION_SUCCESS,
      payload: {
        address,
      },
    }
  }

  static modifyTransactionFail(error) {
    return {
      type: types.MODIFY_TRANSACTION_FAIL,
      payload: {
        error,
      },
    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/remove/actions/address.js